/**
 * Created by 吴佳俊 on 2022/11/21.
 * 多语言配置
 */
import id from '../../../../react-i18next/locales/id.json';
import time_id from './id/time_id.json';
import company_type_id from './id/company_type_id.json';
import response_id from './id/response_id.json';
import menu_id from './id/menu_id.json';
import withdraw_id from './id/withdraw_id.json';
import button_id from './id/button_id.json';
import common_id from './id/common_id.json';
import top_up_id from './id/top_up_id.json';
import admin_id from './id/admin_id.json';
import fee_id from './id/fee_id.json';
import mch_id from './id/mch_id.json';
import protocol_id from './id/protocol_id.json';
import role_id from './id/role_id.json';
import permission_id from './id/permission_id.json';
import fund_source_id from './id/fund_source_id.json';
import file_id from './id/file_id.json';
import account_id from './id/account_id.json';
import country_id from './id/country_id.json';
import enterprise_id from './id/enterprise_id.json';
import exchange_rate_id from './id/exchange_rate_id.json';
import identity_id from './id/identity_id.json';
import order_id from './id/order_id.json';
import password_id from './id/password_id.json';
import store_id from './id/store_id.json';
import settle_id from './id/settle_id.json';

import en from '../../../../react-i18next/locales/en.json';
import time_en from './en/time_en.json';
import company_type_en from './en/company_type_en.json';
import response_en from './en/response_en.json';
import menu_en from './en/menu_en.json';
import withdraw_en from './en/withdraw_en.json';
import button_en from './en/button_en.json';
import common_en from './en/common_en.json';
import top_up_en from './en/top_up_en.json';
import admin_en from './en/admin_en.json';
import fee_en from './en/fee_en.json';
import mch_en from './en/mch_en.json';
import protocol_en from './en/protocol_en.json';
import role_en from './en/role_en.json';
import permission_en from './en/permission_en.json';
import fund_source_en from './en/fund_source_en.json';
import file_en from './en/file_en.json';
import account_en from './en/account_en.json';
import country_en from './en/country_en.json';
import enterprise_en from './en/enterprise_en.json';
import exchange_rate_en from './en/exchange_rate_en.json';
import identity_en from './en/identity_en.json';
import order_en from './en/order_en.json';
import password_en from './en/password_en.json';
import store_en from './en/store_en.json';
import settle_en from './en/settle_en.json';

import zh from '../../../../react-i18next/locales/zh.json';
import time_zh from './zh/time_zh.json';
import company_type_zh from './zh/company_type_zh.json';
import response_zh from './zh/response_zh.json';
import menu_zh from './zh/menu_zh.json';
import withdraw_zh from './zh/withdraw_zh.json';
import button_zh from './zh/button_zh.json';
import common_zh from './zh/common_zh.json';
import top_up_zh from './zh/top_up_zh.json';
import admin_zh from './zh/admin_zh.json';
import fee_zh from './zh/fee_zh.json';
import mch_zh from './zh/mch_zh.json';
import protocol_zh from './zh/protocol_zh.json';
import role_zh from './zh/role_zh.json';
import permission_zh from './zh/permission_zh.json';
import fund_source_zh from './zh/fund_source_zh.json';
import file_zh from './zh/file_zh.json';
import account_zh from './zh/account_zh.json';
import country_zh from './zh/country_zh.json';
import enterprise_zh from './zh/enterprise_zh.json';
import exchange_rate_zh from './zh/exchange_rate_zh.json';
import identity_zh from './zh/identity_zh.json';
import order_zh from './zh/order_zh.json';
import password_zh from './zh/password_zh.json';
import store_zh from './zh/store_zh.json';
import settle_zh from './zh/settle_zh.json';

export const resources = {
    'id-ID': {
        translation: {
            ...time_id,
            ...company_type_id,
            ...response_id,
            ...menu_id,
            ...withdraw_id,
            ...button_id,
            ...common_id,
            ...top_up_id,
            ...admin_id,
            ...fee_id,
            ...mch_id,
            ...protocol_id,
            ...role_id,
            ...permission_id,
            ...fund_source_id,
            ...file_id,
            ...account_id,
            ...country_id,
            ...enterprise_id,
            ...exchange_rate_id,
            ...identity_id,
            ...order_id,
            ...password_id,
            ...store_id,
            ...settle_id,
            ...id,
        },
    },
    'en-US': {
        translation: {
            ...time_en,
            ...company_type_en,
            ...response_en,
            ...menu_en,
            ...withdraw_en,
            ...button_en,
            ...common_en,
            ...top_up_en,
            ...admin_en,
            ...fee_en,
            ...mch_en,
            ...protocol_en,
            ...role_en,
            ...permission_en,
            ...fund_source_en,
            ...file_en,
            ...account_en,
            ...country_en,
            ...enterprise_en,
            ...exchange_rate_en,
            ...identity_en,
            ...order_en,
            ...password_en,
            ...store_en,
            ...settle_en,
            ...en,
        },
    },
    'zh-CN': {
        translation: {
            ...time_zh,
            ...company_type_zh,
            ...response_zh,
            ...menu_zh,
            ...withdraw_zh,
            ...button_zh,
            ...common_zh,
            ...top_up_zh,
            ...admin_zh,
            ...fee_zh,
            ...mch_zh,
            ...protocol_zh,
            ...role_zh,
            ...permission_zh,
            ...fund_source_zh,
            ...file_zh,
            ...account_zh,
            ...country_zh,
            ...enterprise_zh,
            ...exchange_rate_zh,
            ...identity_zh,
            ...order_zh,
            ...password_zh,
            ...store_zh,
            ...settle_zh,
            ...zh,
        },
    },
};
